import * as React from "react";

const NISLoginIcon: React.FC = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
<path d="M7 8.00043C9.07129 8.00043 10.75 6.32142 10.75 4.25043C10.75 2.17943 9.07129 0.500427 7 0.500427C4.92871 0.500427 3.25 2.17943 3.25 4.25043C3.25 6.32142 4.92871 8.00043 7 8.00043ZM8.48535 9.40668H5.51465C2.71123 9.40668 0.4375 11.6801 0.4375 14.4838C0.4375 15.0446 0.892188 15.4995 1.45293 15.4995H12.5477C13.1084 15.5004 13.5625 15.0463 13.5625 14.4838C13.5625 11.6801 11.2891 9.40668 8.48535 9.40668Z" fill="white"/>
</svg>

    );
};

export default React.memo(NISLoginIcon);
